<template>
  <Toast />
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "./App.scss";

.p-button.p-button-info {
    background: #5a6268 !important;
    border-color: #545b62 !important;
    color: #fff !important;
}

.p-button.p-button-info:hover {
  background: #52575b !important;
    border-color: #52575b !important;
    color: #fff !important;
}
</style>
